import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article className="group cursor-pointer">
      <Link to={`/article/${article.id}`} className="block">
        <div className="relative overflow-hidden rounded-lg mb-3 aspect-[3/2]">
          <img
            src={article.imageUrl}
            alt={article.title}
            title={article.title}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
          <div className="absolute top-2 left-2 flex gap-1.5">
            <span className="bg-accent-500 text-background-50 text-xs px-2 py-0.5 rounded-full font-medium">
              {article.category}
            </span>
            {article.isHot && (
              <span className="bg-primary-600 text-background-50 text-xs px-2 py-0.5 rounded-full font-medium flex items-center gap-0.5">
                <i className="ri-fire-line text-[10px]"></i>热门
              </span>
            )}
            {article.isNew && (
              <span className="bg-secondary-500 text-background-50 text-xs px-2 py-0.5 rounded-full font-medium">
                新瓜
              </span>
            )}
          </div>
        </div>
        <h3 className="text-sm md:text-base font-medium text-foreground-950 leading-snug mb-2 group-hover:text-accent-600 transition-colors line-clamp-2">
          {article.title}
        </h3>
        <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <div className="flex items-center gap-2">
            <img
              src={article.authorAvatar}
              alt={article.author}
              className="w-5 h-5 rounded-full object-cover"
            />
            <span>{article.author}</span>
          </div>
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line text-[10px]"></i>
              {article.readCount > 10000
                ? `${(article.readCount / 10000).toFixed(1)}万`
                : article.readCount}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-chat-3-line text-[10px]"></i>
              {article.commentCount}
            </span>
            <span>{article.date}</span>
          </div>
        </div>
      </Link>
    </article>
  );
}